<template>
  <div class="layout">
    <div class="header">
      <div style="margin: 0px 15%;position: relative">
        <img @click="success" src="/img/login/blue_link_small.png"
             style=" cursor: pointer;margin-left: -4px; width: 94px;">
        <span style="margin-left: 24px;margin-right: 6px">|</span><span>注册新用户</span>
        <span style="position: absolute;right: 0px;">已有账号？前往
            <span class="tologin" @click="success">[登录]</span>
        </span>
      </div>
    </div>
    <div class="div_center">
      <div class="register_card" style="width:600px;">
        <div>
<!--         <p style="color:red;">(重要提示：因春节放假，2月15日至2月23日的用户注册，于2月24日统一审核处理，给您带来的不便敬请谅解！祝您春节快乐，万事如意！)</p>-->

<!--          <p v-if="showNotice" style="color:red;">-->
<!--            (重要提示：因春节放假，2月15日至2月23日的用户注册，于2月24日统一审核处理，给您带来的不便敬请谅解！祝您春节快乐，万事如意！)-->
<!--          </p>-->
          <Tabs value="name2" class="ivu-tabs-nav-scroll ivu-tabs-nav-scroll"
                style="width:100%;height:750px;overflow: auto">
            <!-- <TabPane label="邮箱注册" name="name1" disabled='true'>标签一的内容</TabPane> -->
            <!--            <TabPane label="手机号注册" name="name2" style="padding: 16px 12px 16px 18px">
                          <Steps :current="current" class="stepst" direction="horizontal" >
                            <Step title="身份验证"></Step>
                            <Step title="填写信息"></Step>
                            <Step title="完成"></Step>
                          </Steps>
                          <div style="padding-right: 10px;margin-bottom: 16px;">
                            <Form key="form1" ref="formInline1" :model="formItem" v-if="current==0" label-position="left" :label-width="70"
                                  :rules="ruleInline1" >
                              <FormItem label="手机号" prop="tel">
                                <Input  type="text" v-model="formItem.tel" placeholder="请输入手机号">
                                  <Icon type="ios-call-outline" slot="prepend"></Icon>
                                </Input>
                              </FormItem>
                              <FormItem label="验证码" prop="code">
                                <Row justify="space-between">

                                  <Col span="18">
                                    <Input type="text" v-model="formItem.code" placeholder="请输入验证码">
                                      <Icon type="ios-unlock-outline" slot="prepend"></Icon>
                                    </Input>
                                  </Col>
                                  <Col span="5" push="0">
                                    <Button @click="sendPhone" id='button1' style="padding: 0px;text-align: center;" v-if="time!=0 && time!=60">{{ time }}</Button>
                                    <Button @click="sendPhone" id='button1' style="padding: 0px;text-align: center;" v-else>发送验证码</Button>
                                  </Col>
                                </Row>
                              </FormItem>
                            </Form>
                            <Form key="form2" ref="formInline2" :rules="ruleInline2" :model="formItem" v-if="current==1"
                                  label-position="left" :label-width="100">
                              <FormItem label="密码" prop='password1'>
                                <Input type="password" v-model="formItem.password1" placeholder="请输入6-15位的数字、英文组成的密码">
                                </Input>
                              </FormItem>
                              <FormItem label="确认密码" prop='password2'>
                                <Input type="password" v-model="formItem.password2" placeholder="请再次输入密码">
                               </Input>
                              </FormItem>
                              <FormItem label="姓名" prop='name'>
                                <Input type="text" v-model="formItem.name" placeholder="请填入您的姓名">
                                </Input>
                              </FormItem>
                              <FormItem label="所在单位名称" prop='company'>
                                <Select v-model="formItem.company" filterable :loading="loading1" :remote-method="remoteMethod1"
                                        placeholder="请输入所在单位名称">
                                  <Option v-for="item in options1" :key="item.value" :value="item.value"> {{ item.value }}</Option>
                                </Select>
                              </FormItem>
                              <FormItem label="身份" prop='identity'>
                                <Select v-model="formItem.identity" placeholder="请选择您的身份">
                                  <Option v-for="item in options2" :key="item.value" :value="item.value">{{ item.value }}</Option>
                                </Select>
                              </FormItem>
                            </Form>
                            <div v-if="current==2" style="text-align: center;line-height: 36px;margin-top: 45px">
                              <Icon type="ios-checkmark-circle" style="color: #2d8cf0;font-size: 36px"/>
                              <p>注册成功，请用注册手机号登录使用</p></div>
                          </div>
                          <div class="btns">
                            <Button type="primary" @click="next" v-if="current!=2" style="margin-top: 12px;width: 100px">下一步</Button>
                            <Button type="primary" @click="success" v-else style="margin-top: 12px;width: 100px">完成</Button>
                          </div>
                        </TabPane>-->
            <TabPane label="用户注册" name="name2" style="padding: 16px 12px 16px 18px">
              <Steps :current="current" class="stepst" direction="horizontal">
                <Step title="身份验证"></Step>
                <Step title="手机验证"></Step>
                <Step title="填写信息"></Step>
                <Step title="完成"></Step>
              </Steps>
              <div style="padding-right: 10px;margin-bottom: 16px;">
                <Form key="form1" ref="registerDetail1" :model="schoolFrom" v-if="current === 0" label-position="left"
                      :label-width="70"
                      :rules="studentNameRule">
                  <FormItem label="学校全称" prop="schoolName">
                    <Select v-model="schoolFrom.schoolName" filterable style="margin-left: 15px">
                      <Option v-for="schoolName in schoolNameList" :value="schoolName.adress" :key="schoolName.id">
                        {{ schoolName.adress }}
                      </Option>
                    </Select>
                  </FormItem>
                  <FormItem label="身份" prop="identity">
                    <RadioGroup v-model="schoolFrom.identity" style="margin-left: 20px">
                      <Radio label="teacher" style="margin-right: 10px"><span>教师</span></Radio>
                      <Radio label="student" style="margin-right: 10px"><span>在读博士生</span></Radio>
                      <Radio label="researcher" style="margin-right: 10px"><span>其他研究人员</span></Radio>
                    </RadioGroup>
                  </FormItem>
                </Form>
                <Form key="form2" ref="formInline1" :model="schoolFrom" v-if="current === 1" label-position="left"
                      :label-width="70"
                      :rules="ruleInline1">
                  <FormItem label="手机号" prop="tel">
                    <Input type="text" v-model="schoolFrom.tel" placeholder="请输入手机号">
                      <Icon type="ios-call-outline" slot="prepend"></Icon>
                    </Input>
                  </FormItem>
                  <FormItem label="验证码" prop="code">
                    <Row justify="space-between">

                      <Col span="18">
                        <Input type="text" v-model="schoolFrom.code" placeholder="请输入验证码">
                          <Icon type="ios-unlock-outline" slot="prepend"></Icon>
                        </Input>
                      </Col>
                      <Col span="5" push="0">
                        <Button @click="sendPhone" id='button1' style="padding: 0;text-align: center;"
                                v-if="time!==0 && time!==60">{{ time }}
                        </Button>
                        <Button @click="sendPhone" id='button1' style="padding: 0;text-align: center;" v-else>发送验证码
                        </Button>
                      </Col>
                    </Row>
                  </FormItem>
                </Form>
                <Form key="form3" ref="registerDetail2"
                      :rules="this.isTeBieSchool? tebieRule : (!schoolFrom.subIdentity? firstRule : (schoolFrom.identity === 'teacher' ? teacherRule : schoolFrom.identity === 'student' ? studentRule : otherRule))"
                      :model="schoolFrom" v-if="current === 2"
                      label-position="left" :label-width="100">
                  <FormItem prop="subIdentity" label="身份选项" v-if="schoolFrom.identity === 'researcher'">
                    <RadioGroup v-model="schoolFrom.subIdentity">
                      <Radio label="masterStu"><span>硕士生</span></Radio>
                      <Radio label="undergraduateStu"><span>本科生</span></Radio>
                      <Radio label="other"><span>其他工作人员(如博士后)</span></Radio>
                    </RadioGroup>
                  </FormItem>
                  <!--                  <FormItem label="账号名" prop='accountName'>
                                      <Input type="text" v-model="schoolFrom.accountName" placeholder="账号名"></Input>
                                    </FormItem>
                                    <FormItem label="密码" prop='password'>
                                      <Input type="text" v-model="schoolFrom.password" placeholder="密码"></Input>
                                    </FormItem>-->
                  <template v-if="schoolFrom.identity !== 'researcher' || schoolFrom.subIdentity || this.isTeBieSchool">
                    <FormItem label="姓名" prop='username'>
                      <Input type="text" v-model="schoolFrom.username" placeholder="姓名"></Input>
                    </FormItem>
                    <!--                  <FormItem label="电话" prop='tel'>
                                        <Input type="text" v-model="schoolFrom.tel" placeholder="电话"></Input>
                                      </FormItem>-->
                    <FormItem label="学院" prop='college'>
                      <Input type="text" v-model="schoolFrom.college" placeholder="学院"></Input>
                    </FormItem>
                    <FormItem label="系别" prop='department' v-if="this.isTeBieSchool===false">
                      <Input type="text" v-model="schoolFrom.department" placeholder="系别"></Input>
                    </FormItem>
                    <!--                  <FormItem label="个人邮箱" prop='email' v-if="schoolFrom.identity === 'student' || schoolFrom.identity === 'other' || schoolFrom.certificates === 'other'" >
                                        <Input type="text" v-model="schoolFrom.email" placeholder="个人邮箱"></Input>
                                      </FormItem>-->
                    <FormItem label="学号" prop='stuNum'
                              v-if="(schoolFrom.identity === 'student'  || (schoolFrom.identity === 'researcher' && schoolFrom.subIdentity === 'masterStu' || schoolFrom.subIdentity === 'undergraduateStu')) && this.isTeBieSchool===false">
                      <Input type="number" v-model="schoolFrom.stuNum" placeholder="学号"></Input>
                    </FormItem>
                    <template v-if="schoolFrom.identity !== 'teacher'">
                      <FormItem label="入学年份" prop='enrollmentYear'
                                v-if="(schoolFrom.identity === 'student' || schoolFrom.subIdentity === 'masterStu' || schoolFrom.subIdentity === 'undergraduateStu' || schoolFrom.subIdentity === 'other') && this.isTeBieSchool===false">
                        <Input type="text" v-model="schoolFrom.enrollmentYear" placeholder="入学年份"></Input>
                      </FormItem>
                      <FormItem label="学制" prop='eduSys'
                                v-if="(schoolFrom.identity === 'student' || schoolFrom.subIdentity === 'masterStu' || schoolFrom.subIdentity === 'undergraduateStu' || schoolFrom.subIdentity === 'other') && this.isTeBieSchool===false">
                        <Input type="text" v-model="schoolFrom.eduSys" placeholder="学制"></Input>
                      </FormItem>
                    </template>
                    <FormItem label="身份验证" prop='certificates'
                              v-if="(schoolFrom.identity === 'teacher' || this.isTeBieSchool) && this.isTeBieSchool===false">
                      <RadioGroup v-model="schoolFrom.certificates">
                        <Radio label="workMail"><span>工作邮箱</span></Radio>
                        <Radio label="other" v-if="this.isTeBieSchool===false"><span>其他(如：工作证、校园卡等身份证明)</span></Radio>
                      </RadioGroup>
                    </FormItem>
                    <FormItem label="工作邮箱" prop='workMail'
                              v-if="(schoolFrom.identity === 'teacher' && schoolFrom.certificates ==='workMail') || this.isTeBieSchool">
                      <Input type="text" v-model="schoolFrom.workMail" placeholder="工作邮箱" @input="valEmail">
                        <template slot="append">
                          <Select  v-model="oneSchoolMailSuf"
                                  :style="{width: (this.mailSufSize + 2) * 10 + 'px'}" :value="123">
                            <Option v-for="items in schoolMailSuf.split(',')" :value="items"  @click.native="SelectValEmail">{{ items }}</Option>
                          </Select>
                        </template>
                      </Input>
                      <div class="tab_s" id="emailxibietip"
                           style="display:none;float:left;height:30px;padding:4px 10px;color: red"> *&nbsp;该邮箱已注册！
                      </div>
                    </FormItem>

                    <FormItem label="上传证件" prop='voucher'
                              v-if="((schoolFrom.identity === 'teacher' && schoolFrom.certificates ==='other') || schoolFrom.identity === 'student' || schoolFrom.identity === 'researcher') && this.isTeBieSchool===false">
                      <div style="display: flex">
                        <Upload
                            :before-upload="voucherUpload"
                            :max-size="2000"
                            action="#"
                            accept=".jpg,.png,.jpeg">
                          <Button icon="ios-cloud-upload-outline" class="uploadButton">
                            {{ this.voucherUploadMsg }}
                          </Button>
                        </Upload>
                        <Button v-if="schoolFrom.voucherFile" class="uploadButton" @click="showPreview('voucher')"
                                style="margin-left: 30px;margin-top: 1px">查看预览
                        </Button>
                      </div>
                      <p style="color: #2d8cf0;font-size: 11px">·　学生证,校园卡,工作证等身份证明。<br/>·　可上传格式为.jpg/.png/.jpeg 不大于8MB
                      </p>
                    </FormItem>
                    <FormItem label="上传资料" prop='details'
                              v-if="(schoolFrom.identity === 'student' || schoolFrom.identity === 'researcher') && this.isTeBieSchool===false"
                              style="position: relative;top: 30px;">
                      <div style="display: flex">
                        <Upload
                            :before-upload="detailsUpload"
                            accept=".jpg,.png,.jpeg"
                            action="#"
                            :max-size="2000">
                          <Button icon="ios-cloud-upload-outline" class="uploadButton">
                            {{ this.detailsUploadMsg }}
                          </Button>
                        </Upload>
                        <Button v-if="schoolFrom.detailsFile" class="uploadButton" @click="showPreview('details')"
                                style="margin-left: 30px;margin-top: 1px">查看预览
                        </Button>
                      </div>
                      <p style="color: #2d8cf0;font-size: 11px">·　可上传格式为.jpg/.png/.jpeg 不大于8MB</p>
                      <p class="downloadDetail" @click="downloadGO">下载《爱文本数据使用协议》</p>
                    </FormItem>
                    <FormItem label="个人邮箱" prop='email'
                              v-if="(schoolFrom.certificates !== 'workMail' || schoolFrom.identity === 'student' || schoolFrom.identity === 'researcher') && this.isTeBieSchool===false"
                              :style="schoolFrom.identity==='teacher' ? 'margin-top: 30px;': 'margin-top: 60px;'">
                      <Input type="text" v-model="schoolFrom.email" placeholder="个人邮箱（请输入完整邮箱地址）"></Input>
                    </FormItem>
                  </template>

                  <!-- 协议框-->
                  <Collapse :value="currentFoldPanel" v-if="schoolFrom.identity === 'teacher' || this.isTeBieSchool"
                            style="border: 1px solid #2d8cf0;">
                    <Panel name="1">
                      请点击阅读爱文本数据使用协议
                      <div slot="content">
                        <p style="text-align: center">爱文本数据使用协议</p>
                        <p style="word-wrap: break-word;word-break: break-all;">
                          尊敬的用户，您好！<br/>
                          您所在高校采购了我司爱文本数据库产品使用权，根据合同约定，经您注册，我<br/>司开立一个正式账户交付您使用，并请您遵守如下承诺：<br/>
                          1．承认数据及其文档的所有权属于我司所有。同意并保证采取必要和合适的措<br/>施保护数据资料和数据的版权和所有权（数据库及其文档受中华人民共和国<br/>《著作权法》、《商标法》及国际协约条款的保护）。<br/>
                          2．承诺不把我司提供的数据的全部或部分资料和数据以任何形式转移、出售和<br/>公开给任何第三者。<br/>
                          3．承诺只供本人有署名的研究项目中使用。<br/>
                          4．承诺只把数据库数据用于学术研究，不用于商业目的。<br/>
                          5．承诺如果将我司提供的数据库产品用于学术成果中，应当注明数据来源。<br/>
                        </p>
<!--                        <p style="text-align: right">上海经禾信息技术有限公司</p>-->
                        <p :style="'text-align: center;color:' + consentAgreementColor">
                          <Checkbox v-model="consentAgreement">我同意</Checkbox>
                        </p>
                      </div>
                    </Panel>
                  </Collapse>
                </Form>
                <div v-if="current === 3" style="text-align: center;line-height: 36px;margin-top: 45px">
                  <div class="success-title">
                    <svg width="49" height="48" viewBox="0 0 49 48" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                          d="M26.1172 40.3734C16.9391 40.3734 9.49999 32.9344 9.49999 23.7563C9.49999 14.5781 16.9391 7.13907 26.1172 7.13907C35.2953 7.13907 42.7344 14.5781 42.7344 23.7563C42.7344 32.9344 35.2953 40.3734 26.1172 40.3734ZM34.4234 17.0063L23.5156 28.2891L18.6078 23.2406C18.3922 23.0156 18.0969 22.8938 17.7875 22.8938C17.4781 22.8938 17.1828 23.0203 16.9672 23.2406C16.5125 23.7141 16.5125 24.4594 16.9672 24.9328L22.7141 30.8438C22.9531 31.0969 23.2953 31.2234 23.6422 31.1906C23.9891 31.1578 24.3031 30.9703 24.4906 30.675L36.0687 18.6984C36.5234 18.225 36.5234 17.4797 36.0687 17.0063C35.8531 16.7813 35.5578 16.6594 35.2484 16.6594C34.9391 16.6547 34.6437 16.7813 34.4234 17.0063V17.0063Z"
                          fill="#2D8CF0"/>
                      <path d="M9.1625 5.34375L4.49844 9.19688L10.5687 11.2313L9.1625 5.34375Z" fill="#2D8CF0"
                            fill-opacity="0.7"/>
                      <path d="M46.9063 9.90469L43.4187 7.73438V12.075L46.9063 9.90469Z" fill="#2D8CF0"
                            fill-opacity="0.47"/>
                      <path d="M5.35625 14.9203L2.09375 17.4094L6.15312 18.9469L5.35625 14.9203Z" fill="#2D8CF0"/>
                    </svg>
                    <span>注册成功！</span>
                  </div>
                  <div class="success-info">
                    <!--                    <p class="info-default">{{ "我们已经向您的邮箱 "+ this.schoolFrom.certificates === "workMail" ? this.schoolFrom.workMail : this.schoolFrom.email +" 发送了一份验证邮件，请进入邮箱验证" }}</p>-->
                    <p class="info-default">尊敬的用户，您好！</p>
                    <p class="info-default">爱文本已发送了一份验证邮件，请在48小时内内登录您的注册邮箱进行验证，谢谢。</p>
                  </div>
                </div>
              </div>
              <div class="btns">
                <Button type="primary" @click="() => {this.current--}" v-if="current !== 0 && current !== 3"
                        style="margin-top: 12px;width: 100px;margin-right: 20px">上一步
                </Button>
                <Button type="primary" @click="schoolNext" v-if="current !== 3" style="margin-top: 12px;width: 100px">
                  下一步
                </Button>
<!--                                <Button type="primary" @click="() => { this.current ++}" v-if="current !== 3" style="margin-top: 12px;width: 100px">测试</Button>-->
                <Button type="primary" @click="success" v-else style="margin-top: 12px;width: 100px">完成</Button>
              </div>
            </TabPane>
          </Tabs>
        </div>
      </div>
    </div>
    <!--    -->
    <Modal
        v-model="modal1"
        title="提示消息!"
        @on-ok="modalBtn"
        @on-cancel="modalBtn">
      <p>{{ modalMsg }}</p>
    </Modal>
    <!--    图片预览-->
    <Modal
        width="1280"
        v-model="previewPictureModal"
        :title="this.previewPictureTitle"
        @on-ok="() => this.previewPictureModal = false">
      <div style="width:1250px;height:720px;">
        <img :src="this.previewPictureSrc" alt="" style="width: 100%;height: 100%"/>
      </div>
    </Modal>
    <Modal
        width="1280"
        top="10"
        v-model="pdfPreviewPictureModal"
        :title="this.previewPictureTitle"
        @on-ok="() => this.previewPictureModal = false">
      <div style="height: 720px;overflow: auto">
        <pdf :src="this.previewPdfSrc" width="1250" height="720"/>
      </div>
    </Modal>
  </div>

</template>

<script>
import axios from 'axios';
import pdf from 'vue-pdf'
import globalFunction  from "../api/globalFunction.js";
export default {
  components: {
    pdf,
  },
  data() {
    return {
      isTeBieSchool: false,
      isPdf: false,
      consentAgreementColor: '#515A6E',
      currentFoldPanel: '',
      consentAgreement: false,
      previewPictureTitle: '',
      previewPdfSrc: '',
      previewPictureSrc: '',
      pdfPreviewPictureModal: false,
      previewPictureModal: false,
      detailsFileName: "",
      voucherFileName: "",
      mailSufSize: 0,
      oneSchoolMailSuf: "",
      isSubscribed: false,
      modalMsg: "",
      modal1: false,
      schoolMailSuf: '', // 工作邮箱后缀
      detailsUploadMsg: '请上传您亲笔签名的数据使用协议  ',
      voucherUploadMsg: '请点击上传证件  ',
      schoolNameList: [],
      schoolFrom: {
        /*accountName: '', //账号名
        password: '',// 密码*/
        schoolName: '', //学校名
        identity: '', // 身份
        username: '', // 姓名\用户名
        tel: '', // 电话号码
        college: '', // 学院
        department: '', // 院系\部门
        email: '', // 邮箱
        stuNum: '', // 学号
        enrollmentYear: '', // 入学年份
        eduSys: '', // 学制
        certificates: 'workMail', // 证件 默认选中工作邮箱
        workMail: '', // 工作邮箱
        subIdentity: '', // 子身份 默认选中其他工作人员
        details: '', // 资料名
        voucher: '', // 凭证名
        detailsFile: '', // 资料文件
        voucherFile: '', // 凭证文件
      },
      formItem: {
        tel: '',
        code: '',
        password1: '',
        password2: '',
        name: '',
        company: '',
        identity: '',
      },
      time: 60,
      current: 0,
      studentNameRule: {
        schoolName: [
          {required: true, message: '请选择学校', trigger: 'change'},
        ],
        identity: [{required: true, message: '请选择身份', trigger: 'change'},]
      },
      studentRule: {
        username: [{type: 'string', required: true, message: '请输入姓名', trigger: 'blur'},],
        department: [{type: 'string', required: true, message: '请输入院系', trigger: 'blur'},],
        tel: [
          {type: 'string', required: true, message: '请输入正确的手机号码', trigger: 'blur'},
          {pattern: '^[0-9]{11}$', message: '请输入正确的手机号码', trigger: 'blur'}
        ],
        college: [{type: 'string', required: true, message: '请输入正确的学院', trigger: 'blur'},],
        enrollmentYear: [{type: 'string', required: true, message: '请输入正确的入学年份', trigger: 'blur'},],
        eduSys: [{type: 'string', required: true, message: '请输入正确的学制', trigger: 'blur'},],
        stuNum: [{type: 'string', required: true, message: '请输入学号', trigger: 'blur'},],
        details: [
          {
            type: 'string',
            validator: (rule, value, callback) => this.callbackFileMessage(rule, value, callback, "details"),
            trigger: 'change'
          }
        ],
        voucher: [
          {
            type: 'string',
            validator: (rule, value, callback) => {
              return this.callbackFileMessage(rule, value, callback, "voucher")
            },
            trigger: 'change'
          }
        ],
        email: [
          {type: 'string', required: true, message: '请输入个人邮箱', trigger: 'blur'},
        ],
      },
      firstRule: {
        subIdentity: [
          {type: 'string', required: true, message: '请选择身份选项', trigger: 'blur'},
        ]
      },
      tebieRule:{
        subIdentity: [
          {type: 'string', required: true, message: '请选择身份选项', trigger: 'blur'},
        ],
        schoolName: [
          {type: 'string', required: true, message: '请选择学校', trigger: 'blur'},
        ],
        email: [
          {type: 'string', required: true, message: '请输入个人邮箱', trigger: 'blur'},
        ],
        username: [
          {type: 'string', required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        tel: [
          {type: 'string', required: true, message: '请输入正确的手机号码', trigger: 'blur'},
          {pattern: '^[0-9]{11}$', message: '请输入正确的手机号码', trigger: 'blur'}
        ],
        department: [
          {type: 'string', required: true, message: '请输入院系', trigger: 'blur'},
        ],
        workMail: [
          {type: 'string', required: true, message: '请输入工作邮箱', trigger: 'blur'}
        ],
        voucher: [
          {
            type: 'string',
            validator: (rule, value, callback) => {
              this.callbackFileMessage(rule, value, callback, "voucher")
            },
            trigger: 'change'
          }
        ],
        college: [
          {type: 'string', required: true, message: '请输入正确的学院', trigger: 'blur'},
        ],
      },
      teacherRule: {
        /*accountName: [
          {type: 'string', required: true, message: '请输入账号名', trigger: 'blur'},
        ],
        password: [
          {type: 'string', required: true, message: '请输入密码', trigger: 'blur'},
        ],*/
        schoolName: [
          {type: 'string', required: true, message: '请选择学校', trigger: 'blur'},
        ],
        email: [
          {type: 'string', required: true, message: '请输入个人邮箱', trigger: 'blur'},
        ],
        username: [
          {type: 'string', required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        tel: [
          {type: 'string', required: true, message: '请输入正确的手机号码', trigger: 'blur'},
          {pattern: '^[0-9]{11}$', message: '请输入正确的手机号码', trigger: 'blur'}
        ],
        department: [
          {type: 'string', required: true, message: '请输入院系', trigger: 'blur'},
        ],
        workMail: [
          {type: 'string', required: true, message: '请输入工作邮箱', trigger: 'blur'}
        ],
        voucher: [
          {
            type: 'string',
            validator: (rule, value, callback) => {
              this.callbackFileMessage(rule, value, callback, "voucher")
            },
            trigger: 'change'
          }
        ],
        college: [
          {type: 'string', required: true, message: '请输入正确的学院', trigger: 'blur'},
        ],
      },
      otherRule: {
        stuNum: [{type: 'string', required: true, message: '请输入学号', trigger: 'blur'},],
        /* accountName: [
           {type: 'string', required: true, message: '请输入账号名', trigger: 'blur'},
         ],
         password: [
           {type: 'string', required: true, message: '请输入密码', trigger: 'blur'},
         ],*/
        schoolName: [
          {type: 'string', required: true, message: '请选择学校', trigger: 'blur'},
        ],
        username: [
          {type: 'string', required: true, message: '请输入姓名', trigger: 'blur'},
        ],
        department: [
          {type: 'string', required: true, message: '请输入院系', trigger: 'blur'},
        ],
        tel: [
          {type: 'string', required: true, message: '请输入正确的手机号码', trigger: 'blur'},
          {pattern: '^[0-9]{11}$', message: '请输入正确的手机号码', trigger: 'blur'}
        ],
        college: [
          {type: 'string', required: true, message: '请输入正确的学院', trigger: 'blur'},
        ],
        enrollmentYear: [
          {type: 'string', required: true, message: '请输入正确的入学年份', trigger: 'blur'},
        ],
        eduSys: [
          {type: 'string', required: true, message: '请输入正确的学制', trigger: 'blur'},
        ],
        details: [
          {
            type: 'string',
            validator: (rule, value, callback) => {
              this.callbackFileMessage(rule, value, callback, "details")
            },
            trigger: 'change'
          }
        ],
        voucher: [
          {
            type: 'string',
            validator: (rule, value, callback) => {
              this.callbackFileMessage(rule, value, callback, "voucher")
            },
            trigger: 'change'
          }
        ],
        email: [
          {type: 'string', required: true, message: '请输入个人邮箱', trigger: 'blur'},
        ],
      },
      ruleInline1: {
        tel: [
          {type: 'string', required: true, message: '请输入正确的手机号码', trigger: 'blur'},
          {pattern: '^[0-9]{11}$', message: '请输入正确的手机号码', trigger: 'blur'},
          // 增加手机号是否已经注册的验证
          {
            validator: (rule, value, cb) => {
              this.validTel(rule, value, cb)
            },
            trigger: 'blur'
          }
        ],
        code: [
          {type: 'string', required: true, message: '请输入验证码', trigger: 'blur'},
          {pattern: '^[0-9]{6}$', message: '请输入六位数字验证码'},
          // 增加一个异步校验
          {
            validator: (rule, value, cb) => {
              this.validCode(rule, value, cb)
            },
            trigger: 'change',
          }
        ]
      },
      ruleInline2: {
        password1: [
          {type: 'string', required: true, min: 6, max: 15, message: '请输入6-15位的数字、英文组成的密码', trigger: 'blur'},
          {pattern: '[A-Za-z0-9]{6,15}$', message: '请输入6-15位的数字、英文组成的密码', trigger: 'blur'},
        ],
        password2: [
          {
            type: 'string',
            required: true,
            validator: (rule, value, cb) => {
              if (this.formItem.password1 == this.formItem.password2)
                cb()
              else
                cb(new Error('两次密码输入不一致'))
            },
            trigger: 'blur',
          }
        ],
        name: [
          {type: 'string', required: true, message: '姓名不能为空'}
        ],
        company: [
          {type: 'string', required: true, message: '单位不能为空'}
        ],
        identity: [
          {type: 'string', required: true, message: '身份不能为空'}
        ]
      },
      PostData: {
        tel: '',
        code: '',
        password: '',
        name: '',
        company: '',
        identity: '',
      },
      setTime: '',
      school: {},
      options1: {},
      loading1: false,
      options2: [
        {
          value: '教师',
        },
        {
          value: '在读博士生',
        },
        {
          value: '其他研究人员',
        },
      ],
    }
  },

  computed: {
    showNotice() {
      const targetDate = new Date('2026-02-14T00:00:00'); // 目标显示时间
      const currentDate = new Date(); // 当前时间
      return currentDate >= targetDate; // 当前时间晚于或等于目标时间时显示
    }
  },
  // 载入时获取所有学校信息
  created() {
    /*axios.get('/api/register/allSchool')
        .then((res) => {
          this.school = res.data.data.map(item => {
            return {
              value: item + '',
              lable: item + ''
            }
          })
        })*/
    this.getSchoolNameList();
    this.$Message.config({
      top: 75,
      duration: 3
    });
  },
  watch: {
    'schoolFrom.certificates'(newValue, oldValue) {
      if (this.schoolFrom.identity === 'teacher') {
        if (newValue === 'workMail') {
          this.teacherRule.voucher[0].required = false;
          this.teacherRule.workMail[0].required = true;
        } else if (newValue === 'other') {
          this.teacherRule.workMail[0].required = false;
          this.teacherRule.voucher[0].required = true;
        }
      }
    },
    'schoolFrom.schoolName'(newVal, oldVal) {
      this.checkSchoolSubscribed(newVal);
    },
    'schoolFrom.voucher'(newVal, oldVal) {
      this.$refs['registerDetail2'].validateField("voucher");
    },
    'schoolFrom.details'(newVal, oldVal) {
      this.$refs['registerDetail2'].validateField("details");
    },
    'schoolFrom.subIdentity'(newVal, oldVal) {
      this.$refs['registerDetail2'].validateField("subIdentity");
    }
  },
  methods: {
    showPreview(type) {
      this.previewPictureSrc = type === 'details' ? URL.createObjectURL(this.schoolFrom.detailsFile) : URL.createObjectURL(this.schoolFrom.voucherFile);
      if (this.isPdf && type === 'details') {
        this.previewPdfSrc = URL.createObjectURL(this.schoolFrom.detailsFile)
        this.pdfPreviewPictureModal = true;
      } else {
        this.previewPictureModal = true;
      }

    },
    // 点击下载文件
    downloadGO() {
      let link = document.createElement('a')
      link.style.display = 'none'
      if (this.schoolFrom.subIdentity === 'undergraduateStu' || this.schoolFrom.subIdentity === 'masterStu') {
        window.open('/api/register/downloadXieYi?school=' + this.schoolFrom.schoolName + '&type=shuoshi')
        // link.href = "https://jinghe-picture.oss-cn-shanghai.aliyuncs.com/aitest-register-agreement/%E7%88%B1%E6%96%87%E6%9C%AC%E6%95%B0%E6%8D%AE%E4%BD%BF%E7%94%A8%E5%8D%8F%E8%AE%AE%EF%BC%88%E5%9C%A8%E8%AF%BB%E6%9C%AC%E7%A7%91%E7%94%9F%2B%E5%9C%A8%E8%AF%BB%E7%A1%95%E5%A3%AB%E7%94%9F%EF%BC%89.pdf";
        // link.setAttribute('download', "爱文本使用协议(在读本科生,在读硕士生).pdf");
        // console.log("开始下载本科生,研究生协议......")
      } else {
        window.open('/api/register/downloadXieYi?school=' + this.schoolFrom.schoolName + '&type=boshi')
        // link.href = "https://jinghe-picture.oss-cn-shanghai.aliyuncs.com/aitest-register-agreement/%E7%88%B1%E6%96%87%E6%9C%AC%E6%95%B0%E6%8D%AE%E4%BD%BF%E7%94%A8%E5%8D%8F%E8%AE%AE%EF%BC%88%E5%9C%A8%E8%AF%BB%E5%8D%9A%E5%A3%AB%E7%94%9F%2B%E5%85%B6%E4%BB%96%E5%B7%A5%E4%BD%9C%E4%BA%BA%E5%91%98%EF%BC%89.pdf";
        // link.setAttribute('download', "爱文本使用协议(在读博士生,其他工作人员).pdf");
        // console.log("开始下载博士生,其他研究人员协议......")
      }
      link.setAttribute("target", "_blank");
      document.body.appendChild(link)
      link.click();
    },
    modalBtn() {
      this.modal1 = false;
    },
    // 检查学校是否订阅
    checkSchoolSubscribed(val) {
      let formData = new FormData();
      formData.append("schoolName", val);
      axios({
        method: 'post',
        url: '/api/register/checkSchoolSubscribed',
        data: formData,
        headers: {'content-type': 'multipart/form-data'},
      }).then((res) => {
        if (res.data.status) {
          this.isSubscribed = true;
          let filter = this.schoolNameList.filter(items => items.adress === val)
          this.schoolMailSuf = filter[0].suf;
          let currentMaxLength = 0;
          const schoolMailSufArr = this.schoolMailSuf.split(',');
          this.oneSchoolMailSuf = schoolMailSufArr[0];
          schoolMailSufArr.forEach((item) => {
            if (item.length > currentMaxLength) {
              currentMaxLength = item.length;
            }
          })
          this.mailSufSize = currentMaxLength;
        } else {
          this.modal1 = true;
          this.modalMsg = res.data.msg
          this.schoolFrom.schoolName = "";
        }
      });
    },

    callbackFileMessage(rule, value, callback, val) {
      const temp = this.schoolFrom[val];
      const tempIndex = temp.lastIndexOf('.');
      let fileSuf = temp.substring(tempIndex);
      if (val === 'details') {
        if (fileSuf !== '.jpg' && fileSuf !== '.png' && fileSuf !== '.jpeg' && fileSuf !== '.pdf') {
          this.schoolFrom[val] = "";
          callback(new Error("请上传资料"));
        } else {
          callback();
        }
      } else {
        if (fileSuf !== '.jpg' && fileSuf !== '.png' && fileSuf !== '.jpeg') {
          this.schoolFrom[val] = "";
          callback(new Error("请上传证件"));
        } else {
          callback();
        }
      }
    },
    // 检查文件类型和大小
    checkFileTypeAndSize(file, index) {
      let temp = file.name.lastIndexOf('.');
      const fileName = file.name.substring(temp);
      if (index === 'details') {
        this.isPdf = fileName === '.pdf';
        if (fileName !== '.jpg' && fileName !== '.png' && fileName !== '.jpeg' && fileName !== '.pdf') {
          this.schoolFrom.details = "";
          this.schoolFrom.detailsFile = "";
          this.detailsUploadMsg = '请选择jpg,png,jpeg,pdf类型的文件!';
          return false;
        }
      } else {
        if (fileName !== '.jpg' && fileName !== '.png' && fileName !== '.jpeg') {
          this.schoolFrom.voucher = "";
          this.schoolFrom.voucherFile = "";
          this.voucherUploadMsg = '请选择jpg,png,jpeg类型的文件!';
          return false;
        }
      }

      if (file.size > 8000 * 1024) {
        index === 'details' ? this.detailsUploadMsg = '文件不能大于8M!' : this.voucherUploadMsg = '文件不能大于8M!'
        return false;
      }
      return true
    },
    // 上传资料
    detailsUpload(file) {
      if (this.checkFileTypeAndSize(file, 'details')) {
        this.detailsUploadMsg = "上传成功,再次点击覆盖上传!";
        this.schoolFrom.details = file.name;
        this.schoolFrom.detailsFile = file;
      }
      return false;
    },
    // 上传证件
    voucherUpload(file) {
      if (this.checkFileTypeAndSize(file, 'voucher')) {
        this.voucherUploadMsg = "上传成功,再次点击覆盖上传!";
        this.schoolFrom.voucher = file.name;
        this.schoolFrom.voucherFile = file;
      }
      return false;
    },
    // 获取学校集合
    getSchoolNameList() {
      axios.get("/api/register/getSchoolDetailList").then((res) => {
        if (res.status === 200) {
          this.schoolNameList = res.data
          this.schoolNameList.forEach((items) => {
            items.adress = items.adress.trim();
          })
        }
      }).catch((e) => {
        console.warn(e)
      })
    },
    SelectValEmail() {
      let formData = new FormData();
      if (this.isTeBieSchool || this.schoolFrom.identity === 'teacher') {
        formData.append("email", this.schoolFrom.workMail.trim() + this.oneSchoolMailSuf);
      } else {
        formData.append("email", this.schoolFrom.email);
      }
      axios({
        method: 'post',
        url: '/api/register/valEmail',
        data: formData,
      }).then((res) => {
        if (res.data.data) {
          $("#emailxibietip").hide();
        } else {
          $("#emailxibietip").show();
          return false;
        }
      });
    },

    valEmail: globalFunction.debounce(function () {
        let formData = new FormData();

        console.log(this.schoolFrom.workMail)
        console.log(this.oneSchoolMailSuf)
        console.log(this.isTeBieSchool)
        console.log(this.schoolFrom.identity)

        if (this.isTeBieSchool || this.schoolFrom.identity === 'teacher') {
          formData.append("email", this.schoolFrom.workMail.trim() + this.oneSchoolMailSuf);
        } else {
          formData.append("email", this.schoolFrom.email);
        }
        axios({
          method: 'post',
          url: '/api/register/valEmail',
          data: formData,
        }).then((res) => {
          if (res.data.data) {
            $("#emailxibietip").hide();
          } else {
            $("#emailxibietip").show();
            return false;
          }
        });
    }, 1000),

    // valEmail () {
    //   let formData = new FormData();
    //   if (this.isTeBieSchool || this.schoolFrom.identity === 'teacher') {
    //     formData.append("email", this.schoolFrom.workMail.trim() + this.oneSchoolMailSuf);
    //   } else {
    //     formData.append("email", this.schoolFrom.email);
    //   }
    //   axios({
    //     method: 'post',
    //     url: '/api/register/valEmail',
    //     data: formData,
    //   }).then((res) => {
    //     if (res.data.data) {
    //       $("#emailxibietip").hide();
    //     } else {
    //       $("#emailxibietip").show();
    //       return false;
    //     }
    //   });
    // },
    // 下一步
    schoolNext() {
      switch (this.current) {
        case 0:
          this.$refs['registerDetail1'].validate((valid) => {
            if (!this.isSubscribed) {
              this.modal1 = true;
              this.modalMsg = "当前学校未订阅!";
            } else {
              let formData = new FormData();
              formData.append("school", this.schoolFrom.schoolName);
              axios({
                method: 'post',
                url: '/api/register/valSpecialSchool',
                data: formData,
              }).then((res) => {
                if (res.data.data) {
                  this.isTeBieSchool = true;
                } else {
                  this.isTeBieSchool = false;
                }
              });
            }
            if (valid && this.isSubscribed === true) this.current++;
          })
          break;
        case 1:
          this.$refs['formInline1'].validate((valid) => {
            if (valid) this.current++;
          })
          break;
        case 2:
          this.$refs['registerDetail2'].validate((valid) => {

            //------------------特殊学校
            if (this.isTeBieSchool && !this.consentAgreement) {
              // 展开协议
              this.currentFoldPanel = "1";
              // 勾选框字体变更为红色
              this.consentAgreementColor = "#ED4014";
              this.$Message.warning("请阅读爱文本数据使用协议！");
              return;
            }
            if ((this.schoolFrom.username === null || this.schoolFrom.username === '') && this.isTeBieSchool) {
              this.$Message.warning("请输入姓名");
              return;
            }
            if ((this.schoolFrom.college === null || this.schoolFrom.college === '') && this.isTeBieSchool) {
              this.$Message.warning("请输入学院");
              return;
            }
            // if((this.schoolFrom.department===null || this.schoolFrom.department==='') && this.isTeBieSchool){
            //   this.$Message.warning("请输入系别");
            //   return;
            // }
            if ((this.schoolFrom.workMail === null || this.schoolFrom.workMail === '') && this.isTeBieSchool) {
              this.$Message.warning("请输入工作邮箱");
              return;
            }


            let formData = new FormData();
            let emailValue;
            if (this.isTeBieSchool || this.schoolFrom.identity === 'teacher') {
              emailValue = this.schoolFrom.workMail?.trim() + this.oneSchoolMailSuf;
            } else {
              emailValue = this.schoolFrom.email?.trim(); // 可选链操作符防止 undefined
            }

            if (!emailValue || emailValue.trim() === '') {
              this.$Message['warning']({
                background: true,
                content: '请输入有效的邮箱地址!'
              });
              return; // 阻止后续操作
            }
            formData.append("email", emailValue);


            axios({
              method: 'post',
              url: '/api/register/valEmail',
              data: formData,
            }).then((res) => {
              if (res.data.data) {

                // 如果身份不是教师 选项工作邮箱 为空
                if (this.schoolFrom.identity !== 'teacher' && this.isTeBieSchool === false) {
                  this.schoolFrom.certificates = ""
                }
                // 教师身份需同意爱文本协议
                if (!this.consentAgreement && this.schoolFrom.identity === 'teacher') {
                  // 展开协议
                  this.currentFoldPanel = "1";
                  // 勾选框字体变更为红色
                  this.consentAgreementColor = "#ED4014";
                  this.$Message.warning("请阅读爱文本数据使用协议！");
                  return;
                }

                if (valid) {
                  if (this.schoolFrom.identity == "researcher" && this.schoolFrom.subIdentity == "") {
                    this.$Message.warning("请选择身份选项");
                    return;
                  }
                  let formData = new FormData();
                  if (this.schoolFrom.detailsFile) {
                    formData.append("detailsFile", this.schoolFrom.detailsFile)
                    delete this.schoolFrom.detailsFile
                  }
                  if (this.schoolFrom.voucherFile) {
                    formData.append("voucherFile", this.schoolFrom.voucherFile)
                    delete this.schoolFrom.voucherFile
                  }
                  if (this.schoolFrom.identity) {
                    switch (this.schoolFrom.identity) {
                      case 'teacher' :
                        this.schoolFrom.identity = '教师';
                        break;
                      case 'student' :
                        this.schoolFrom.identity = '学生';
                        break;
                      case 'researcher' :
                        this.schoolFrom.identity = '其他研究人员';
                        break;
                    }
                  }
                  if (this.schoolFrom.subIdentity) {
                    switch (this.schoolFrom.subIdentity) {
                      case 'masterStu' :
                        this.schoolFrom.subIdentity = '硕士生';
                        break;
                      case 'undergraduateStu' :
                        this.schoolFrom.subIdentity = '本科生';
                        break;
                      case 'other' :
                        this.schoolFrom.subIdentity = '其他工作人员';
                        break;
                    }
                  }

                  this.schoolMailSuf = this.oneSchoolMailSuf;
                  if (this.schoolFrom.certificates === 'workMail') {
                    this.schoolFrom.email = '';
                    // 邮箱加入后缀
                    if (this.schoolFrom.workMail) this.schoolFrom.workMail = this.schoolFrom.workMail.trim() + this.oneSchoolMailSuf;
                  } else {
                    this.schoolFrom.workMail = '';
                    this.schoolMailSuf = '';
                  }

                  formData.append("register", JSON.stringify(this.schoolFrom));
                  axios({
                    method: 'post',
                    url: '/api/register/saveRegister',
                    data: formData,
                    headers: {'content-type': 'multipart/form-data'},
                  }).then((res) => {
                    if (res.data.status) this.$Message.info("提交成功,请查看邮箱!");
                    else this.$Message.info("提交失败,请联系管理员!");
                  }).catch((err) => {
                    console.error(err);
                    this.$Message.info("提交失败,请联系管理员!");
                  });
                  this.current++;
                }

              } else {
                this.$Message['warning']({
                  background: true,
                  content: '该邮箱已经注册!'
                });
                $("#emailxibietip").show();
                //this.$Message.warning(res.data.msg);
              }
            });
          });
          break;
      }
    },

    next() {
      if (this.current === 0 || this.current === 1) {
        this.$refs['formInline' + (this.current + 1)].validate(async (valid) => {
          if (valid) {
            // 防止验证码正确后修改手机号
            if (this.current === 0) {
              // 我觉得需要在后端进行验证？感觉不需要后端验证
              // 刷新页面后会导致保存在this.PostData中的手机号消失，所以需要从后端重新获取
              if (this.PostData.tel === '') {
                await axios.get("/api/register/getTel")
                    .then((res) => {
                      this.PostData.tel = res.data.data
                    })
              }
              if (this.formItem.code !== this.PostData.code || this.formItem.tel !== this.PostData.tel) {
                this.$Message.error("表单提交信息和验证信息不对应，请检查输入手机号或者验证码")
                return
              }
            }
            // 准备提交注册信息
            if (this.current === 1) {
              this.PostData.password = this.formItem.password1
              this.PostData.name = this.formItem.name
              this.PostData.company = this.formItem.company
              this.PostData.identity = this.formItem.identity
              axios.post('/api/register/addUser', this.PostData)
                  .then((res) => {

                  }).catch(() => {
                this.$Message.error('注册失败，请重试');
              })
            }
            // 先不进入第三页
            this.current++;
          } else {
            this.$Message.error('请填写正确的表单信息');
          }
        })
      }
    },
    success() {
      location.assign("https://aitexts.com/")
      // 更改store中的值
      // this.$store.commit('setRegisterFlag', {
      //   flag: false,
      //   flag2: false,
      // })
    },

    // 发送验证码
    sendPhone() {
      // 需要验证手机号正确才可以发送
      this.$refs.formInline1.validateField('tel', (error) => {
        // 如果验证正确则为空
        if (!error) {
          this.PostData.tel = this.formItem.tel
          axios.post("/api/register/sendPhoneMessage", {
            phone: this.schoolFrom.tel
          }).then((res) => {
            if (res.data.status) {
              $('#button1')[0].disabled = true
              // 发送短信后启动定时器
              this.setTime = setInterval(() => {
                //console.log(this.time)
                if (this.time > 0) {
                  this.time--
                }
                if (this.time === 0) {
                  $('#button1')[0].disabled = false
                  clearInterval(this.setTime)
                  this.time = 60
                }
              }, 1000);
              this.$Message.success(res.data.msg)
            } else {
              this.$Message.error(res.data.msg)
            }
          }).catch(() => {
            this.$Message.error("短信发送失败")
          })
        } else {
          this.$Message.error("请输入正确的手机号码")
        }
      })
    },
    // 验证
    async validCode(rule, value, callback) {
      if (this.schoolFrom.code.length === 6) {
        axios.post("/api/register/validCode", {
          code: this.schoolFrom.code
        })
            .then((res) => {
              // 验证码错误需要返回信息
              //console.log(res.data)
              if (res.data.data === '验证成功') {
              //if (true) {
                this.PostData.code = this.formItem.code
                callback()
              } else
                callback(new Error("验证码错误"))
            })
      } else {
        callback(new Error("请输入六位数字验证码"))
      }
    },
    // 验证手机号是否已经注册
    async validTel(rule, value, callback) {
      axios.post('/api/register/validTel', {
        tel: value
      })
          .then((res) => {
            if (res.data.data === "已经存在")
              callback(new Error('手机号已经被注册'))
            else
              callback()
          })
    },

    // 远程搜索
    remoteMethod1(query) {
      if (query !== '') {
        this.loading1 = true;
        setTimeout(() => {
          this.loading1 = false;
          const list = this.school
          this.options1 = list.filter(item => item.lable.indexOf(query) > -1);
        }, 200);
      } else {
        this.options1 = [];
      }
    }
  }
}
</script>

<style scoped>
/deep/ .ivu-input-group-append {
  padding: 0 !important;
}

.downloadDetail {
  position: relative;
  top: -110px;
  height: 10px;
  padding: 0;
}

.downloadDetail:hover {
  color: #57a3f3;
  cursor: pointer;
}

.uploadButton {
  background-color: #2d8cf0;
  color: #ffffff;
}

.uploadButton:hover {
  background-color: #57a3f3;
  color: #ffffff;
}
</style>
<style>
.layout {
  background: #f8f8f9;
  height: 100%;
}

.div_center {
  margin: 0 auto;
  width: 600px;
  height: 100px;
  margin-top: 48px;
}

.register_card {
  background: white;
  padding: 16px;
}

.ivu-tabs-ink-bar {
  opacity: 0;
}

.ivu-tabs-nav .ivu-tabs-tab-active {
  font-size: 14px !important;
  color: #17233d !important;
  font-weight: 700 !important;
}

.ivu-tabs-nav-scroll {
  display: inline-block;
}

#button1 {
  width: 100%
}

.stepst {
  margin: 8px 0px 36px 0px;
}

.header {
  width: 100%;
  background: white;
  height: 64px;
  line-height: 64px;
  box-shadow: 0 1px 3px rgba(26, 26, 26, 0.1);
}

.btns {
  text-align: center;
  padding-right: 10px;
}

.tologin {
  color: #2d8cf0;
  position: relative;
  /*border-bottom: 1px solid;*/
  cursor: pointer;
  letter-spacing: 1px;
  margin-left: 6px;
}

.tologin:hover, .tologin:focus {
  color: #3a74b1;
  border-bottom: 1px solid #3a74b1;
}

a:hover, a:focus {
  outline: none !important;
  color: #3a74b1;
  text-decoration: none !important;
}

/* 注册成功 */
.success-title {
  position: relative;
  width: 160px;
  height: 48px;
  margin: 0 auto;
}

.success-title svg {
  position: absolute;
  left: 0px;
}

.success-title span {
  position: absolute;
  top: 6px;
  left: 60px;
  color: #2D8CF0;
  font-size: 20px;
  font-weight: bold;
}

.success-info {
  margin-top: 36px;
  margin-bottom: 42px;
  text-align: left;
}

.success-info .info-1 {
  color: #353F4B;
  font-size: 18px;
  font-weight: bold;
  line-height: 20px;
  height: 20px;
}

.success-info .info-default {
  color: #353F4B;
  font-size: 15px;
  white-space: break-spaces;
  line-height: 24px;
  margin-top: 14px;
}
</style>
